export default __webpack_public_path__ + "static/media/step_direction.d202554b.png";